import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-brand-ivory text-center text-brand-text text-xs sm:text-sm border-t border-brand-cream" data-id="element-68" data-mp="32wd2cf6gdjt0">
      <p className="leading-relaxed max-w-2xl mx-auto font-medium mb-4" data-id="element-69" data-mp="32nulgo2wc31d">
        © {new Date().getFullYear()} DANCE PRO™ — Tous droits réservés.
        <br data-id="element-70" data-mp="36q9354utwwr2" />
        <br data-id="element-71" data-mp="36pz9n7aks7gm" />
        Les informations présentées sur ce site sont destinées exclusivement à
        des fins pédagogiques et constituent une ressource professionnelle pour
        les professeurs et enseignants de danse. Elles ne remplacent ni votre
        jugement professionnel ni les recommandations pédagogiques de votre
        établissement, école ou organisme de formation. Utilisez toujours votre
        expertise afin d'adapter les contenus aux besoins et au niveau de vos
        élèves.
      </p>
      <div className="flex justify-center gap-3 sm:gap-4 font-bold tracking-wide uppercase text-brand-title" data-id="element-72" data-mp="29xvqyd5xndpb">
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-73" data-mp="2ew734ujpa0ap">
          Conditions Générales
        </a>
        <span data-id="element-74" data-mp="3gah0psdvrh5b">·</span>
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-75" data-mp="3gaz73hu9bbqy">
          Politique de Confidentialité
        </a>
        <span data-id="element-76" data-mp="3v8hrk7zwj2sl">·</span>
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-77" data-mp="3v91a9qxdlv7o">
          Contact
        </a>
      </div>
    </footer>;
}